import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IInviteAgentUserRepository } from 'application/repositorySchemas/IInviteAgentUserRepository';
import { type IInviteAgentUserClient } from 'interfaceAdapter/gatewaySchemas/IInviteAgentUserClient';

@injectable()
export class InviteAgentUserRepository implements IInviteAgentUserRepository {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IInviteAgentUserClient')
        public readonly inviteAgentUserClient: IInviteAgentUserClient,
    ) {}

    public async post(email: string) {
        const { data, message } = await this.inviteAgentUserClient.post({
            token: this.agentUserToken.get() || '',
            email,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
